var _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 23,
    width: 32,
    height: 31,
    fill: "url(#pattern1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1",
    transform: "scale(0.03125 0.0322581)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 80,
    height: 80,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAFtElEQVR4Ae1ci1XkMAykBEqgBDo4OrjrgOsAOoAOjg6gE+gAOoAOoIO5NyBvtBMlTrLJJpvY7+WtE//ksWTJttZnZzMGABcAfgG4AXBnzzMAPq+oAuPpe8rHMix7MWMXjt80gEsA/wSgCqphMQLMOi+P36OJWwRwDuA3gEcAn8Pw6VWKbbAttnk+cfemrd5EMgfaC4AHAPf2XAHgs+Mm49r0PeVjGZZtC2z7btpeTlA7gGsA7w09+wDwBODPWE2zLquTdUeBtFyP1d5k9RjnRMCxY+ScHVdNRYRxK9uKwCRtV1O1PbheI5paUsMXgL+DKz6wINsGQBo0kNbJB7MT+SY+Os+RaHLB7JO4KTHSokCS5nm50ew3HV1O7rMDp6NvQJI2DfNIiJkKnhjOOcsQC0XPvdt0o/Pjo8sybdRG0q8SCOLbErmuCQnrA2n2gfPitJJjo6da9qmJ0KV/N9PHg0jGmEaKbNQUvNulg5SjD8CtR9CWmONzoqxdqdFGM4RznZw63SwJr6WfR20zUBirAS8BZSB6ZhxHsQQsfvJim0DT36Cvh5k4waicrMJQsJreA8UyzNg2jetXGG9Nja7tu5llSZyJQX/NbDvAqRIanuNrpoUibxaHN7b7KRXbVUng8bf/CCwUnK5kmQR6DLqLsuzlPXRtdG35bKM3gfjaqX+2BZQK0TbajOgqQCbK3j7Ma2XhvnutdGvvti2XGOq9tf+SedPcl4AKuDBmKsvozZY8u6ZWVv4r0xoxqk9rYjR/rByT3t2TM5b6UlYs8JhNeze7ngIyvdVXZHLovTm7LzfUYhd+7uWXxCK+e+hULyLGFZOJwVhnz6qOTcdkmqsWGLJZWp8gNw1b1XlRtD8rE3MxS4YiquwlFiGwA+oncnEmGwcvUaHyrUJAHJquCKA/VKnkuipTYg4B0Re3BJBuDykU+8+BFUVreMmH1Z53RGAM+SZ43ZMDvZNi903DIa2voExNZxQA+41qBKD3NtiWx3s/7L5zy6rtlSK8CwPq22SRHWAACoADWEAB9Md3RYQzgIoIvxUtnAFMkyMlUswYRanlPQLQ+w0XQ7oFPCZFhnRZymVA88kRgGUzwSOUiUebCfwPWgplOysP4L7OKBuqGcRcsp2dJ2bj74/ZJ/5wZUvfgeajsqVf+UuKXJdDJY+ai8uhUrV3KtZ1uwONq3BrUXG8qo41CYT8GW8/cWtIBf0VJvuqZWlkz1rObX4Q+68+zckEWcRY+ETEt65oAz+44t5mIIp7W7PfpLBp7AcnI7P218BvstK+UefFgaY9c1TByr4JU+Udr4RdN82FAfd1m9aECzfrrSCWSbXyyEmZbBpyzbc5u1DsPmLQ78xczot59Fl3rM6NxImmm+j6497+u1Q2Av5PJt3+qXOioHmyxV+SGAyTwECUx/kTsqd2YfHgz+X9RFf7I1qZc8Fqz03E1Y997aZ1FTR9F23EiutLGS10Yu+ylGUf6+vdQ/okSoX24WpANPDYpxT6K40cuKaZvBcDG7vJlVt6enB91XSXCJlmVhBPVrEECoPgDdO4XTnFONGfTJETeePPydiJ1ge9vop9Ol4fAsVCw3Pa0es6yi35TIq8kUwGGFdhtLS/lxSYOCSGt+kebyT3KGp+Ma7j5bQaxjFVmptuTzFj269YSCA1Gu97nh1IA460eC1LGknzYUZyOzTdU00sdF5MQM52+atdhqvAkS7SurzpxrhRtTQJ5pxDLpicaBtMtqXzHOmgll0G17Xxp82NEZAJzO+Lstvq6JpmIpou+o5AY5ukZd65rmuHfD7bDtf5kR3ygTdHUvGQa/jwfnw+O241rkrfUz6WiW4O9nWz7dM+ljAOSRdl58D0nR8aZxvfF30vQYl5hholbtxEr1i9w3QoYCzHuugouuPaUYhdeiXmWkf/RDp5EgA+1JB8PMCMp+8pH8uw7Kz/LPgPEVvow53mnlcAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1",
    width: 32,
    height: 31,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAfCAYAAACGVs+MAAABNUlEQVRYCe2X4XHCMAyFPUJHyAjZgI7ACBmBDcgIbAAblA3KBmUDukHZ4ONesA1O7CT0gn9Zdz7bsiK96J7kxBhjDLABfrjLF1BJn0VscBvbTxfgIxeAsw8bLppcAK5hXL9rcwE4+pDhos4FoAJ+w9gcsgR3QUQ4S8YW+HT6Mv83A+ojwArY2rFK+gJOwHdkBGUINBGb7jnnHFg/NbQerbrtftBfYlZWF5QhIH5ERQCAQ/RwqFSTe1TY8NxrZgMAdv6peYtHpx2xfwXAiJvk0d1/8hjeDeCv487CAERocUVD6ympRZ6UvJqBwN4SU5UzJs1SAE6uFPszkLprBKxdCsC6H9jt1dpHUrAYgOQXlGr+7QDc26bmAqBkoGSgZKBkYCoDuixiI+jv9ks3Zjf5H5HwL1/VDWFfYfqivKLxAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.72ca00d4e863e50b6aadbd446297cd4f.svg";
export { ForwardRef as ReactComponent };